/* eslint-disable-next-line  no-unused-vars */
import { createElement, useEffect, useRef } from 'react';
import { createContext, useState } from 'react';
import messageEnums from '../helper/messageEnums';
import { CircularProgress } from '@mui/material';
export const MapContext = createContext();

export default function MapContextProvider({ map, children }) {
    const [mapData, setMapData] = useState([]);
    const [messages, setMessages] = useState({});
    const messageRef = useRef();
    const [mapWorkspace, setMapWorkspace] = useState();
    const [drawing2D, setDrawing2D] = useState();
    const [status2D, setStatus2D] = useState();
    const [drawing3D, setDrawing3D] = useState();
    const [status3D, setStatus3D] = useState();
    const [mapLayerList, setMapLayerList] = useState();
    const [loader, setLoader] = useState(false);

    // useEffect(() => {
    //     console.log(status3D);
    // }, [status3D]);

    useEffect(() => {
        messageRef.current = messages;
    }, [messages]);

    const resetMessages = () => {
        let tmp = messageRef.current;
        for (let item in messageEnums) {
            if (
                Object.prototype.hasOwnProperty.call(messageEnums[item], 'cleanOnChange') &&
                messageEnums[item].cleanOnChange == false
            )
                continue;

            tmp[item] = [];
        }

        // setMessages(tmp);
        return tmp;
    };

    return (
        <MapContext.Provider
            value={{
                map,
                mapData,
                setMapData,
                messages,
                messageRef,
                setMessages,
                resetMessages,
                mapWorkspace,
                setMapWorkspace,
                drawing2D,
                setDrawing2D,
                drawing3D,
                setDrawing3D,
                mapLayerList,
                setMapLayerList,
                setLoader,
                status2D,
                setStatus2D,
                status3D,
                setStatus3D
            }}
        >
            {loader && (
                <CircularProgress
                    size={48}
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px'
                    }}
                />
            )}
            {map !== null ? children : <></>}
        </MapContext.Provider>
    );
}
